// removed by extract-text-webpack-plugin
module.exports = {"ErrorMessage":"ErrorMessage--3itUV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ErrorMessage/ErrorMessage.scss
// module id = 959
// module chunks = 1